(ns ductile.workflow.parking-utils
  (:require [clojure.string :as str]
            [ductile.workflow.parking-data :as parking-data]))

(defn safe-compare [l r]
  (if (= (type l) (type r))
    (compare l r)
    (cond (nil? l) -1
          (nil? r) 1
          ;; kinda doens't matter what comes first, so just deterministically return some
          ;; compare result
          :else (compare (-> l type str) (-> r type str)))))

(defn compare-parking-places [l r]
  (let [zone-compare (safe-compare (:parking-zone/name l)
                                   (:parking-zone/name r))
        row-compare (safe-compare (:parking-spot/row l)
                                  (:parking-spot/row r))
        place-compare (safe-compare (:parking-spot/place l)
                                    (:parking-spot/place r))]
    (or (and (not (zero? zone-compare))
             zone-compare)
        (and (not (zero? row-compare))
             row-compare)
        (and (not (zero? place-compare))
             place-compare))))

(comment
  (compare-parking-places {:parking-zone/name "FZ-LAGER1" :parking-spot/row 51 :parking-spot/place 5}
                          {:parking-zone/name "FZ-LAGER1" :parking-spot/row 51 :parking-spot/place 4})
  (compare-parking-places {:parking-zone/name "FZ-LAGER1" :parking-spot/row 51 :parking-spot/place 3}
                          {:parking-zone/name "FZ-LAGER1" :parking-spot/row 51 :parking-spot/place 4})
  (compare-parking-places {:parking-zone/name "FZ-LAGER1" :parking-spot/row 50 :parking-spot/place 4}
                          {:parking-zone/name "FZ-LAGER1" :parking-spot/row 51 :parking-spot/place 3}))

(defn parking-spot->str
  ;; TODO: remove this once we consistently use the new fat fahrzeug
  [fat-fahrzeug]
  (let [assignment-type (get-in parking-data/zone->dimensions
                                [(:compound/name fat-fahrzeug)
                                 (:parking-zone/name fat-fahrzeug)
                                 :assignment-type])]
    (if (= :zone assignment-type)
      (:parking-zone/name fat-fahrzeug)
      (some->> ((juxt :parking-zone/name :parking-spot/row :parking-spot/place) fat-fahrzeug)
               (remove nil?)
               seq
               (str/join "/")))))

(comment
  (parking-spot->str {:parking-zone/name "A"
                      :parking-spot/row 1
                      :parking-spot/place 2
                      :compound/name "Krefeld"})

  ;; zone that requires no row/place
  (parking-spot->str {:parking-zone/name "Puffer Werkstatt"
                      :parking-spot/row 1
                      :parking-spot/place 2
                      :compound/name "Krefeld"}))
